import { render, staticRenderFns } from "./OnlineList.vue?vue&type=template&id=5bdd515c"
import script from "./OnlineList.vue?vue&type=script&lang=js"
export * from "./OnlineList.vue?vue&type=script&lang=js"
import style0 from "./OnlineList.vue?vue&type=style&index=0&id=5bdd515c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OnlineList.vue?vue&type=custom&index=0&blockType=el-divider"
if (typeof block0 === 'function') block0(component)

export default component.exports